<template>
	<div class="main-content-inner-wrapper tw-relative md:tw-mt-0">
		<div class="events-tabs-mobile tw-fixed tw-z-50 tw-w-full tw-pt-4 tw-flex tw-justify-between primary-c-bg tw-text-white md:tw-hidden">
			<div class="tw-w-1/2 tw-flex tw-justify-center">
				<div class="tw-w-2/3 text-center tw-py-2 tw-font-bold tw-text-sm tw-border-b-2 focus:tw-outline-none" @click="showFutureEvents" :class="view === 'future' ? 'tw-border-white' : 'tw-border-transparent'">{{ $t('events.planned_tense') }}</div>
			</div>
			<div class="tw-w-1/2 tw-flex tw-justify-center">
				<div class="tw-w-2/3 text-center tw-py-2 tw-font-bold tw-text-sm tw-border-b-2 focus:tw-outline-none" @click="showPastEvents" :class="view === 'past'  ? 'tw-border-white' : 'tw-border-transparent'">{{ $t('events.past') }}</div>
			</div>
		</div>

		<event-modal :categories="categories"></event-modal>

		<custom-form :mainContent="true" class="tw-mt-10 tw-mb-6 md:tw-m-6">
			<div class="main-content-center">
				<div class="tw-mx-6 md:tw-mx-0 md:tw-mb-10">
					<div class="tw-flex tw-items-center tw-mb-2 md:tw-mb-0">
						<div class="tw-text-center tw-pr-6">
							<div class="card-v2 calendar-icon tw-p-2 tw-m-0 tw-border-calendar tw-border-t-5 md:tw-border-t-10">
								<h3 class="tw-text-4xl md:tw-text-5xl tw-font-bold tw-leading-tight" v-text="day"></h3>
								<p class="tw-text-lg md:tw-text-2xl uppercase" v-text="month"></p>
							</div>
						</div>
						<div class="tw-flex tw-flex-1 tw-justify-between tw-items-center md:tw-hidden">
							<h3 class="tw-text-2xl tw-font-bold tw-leading-tight tw-mb-1">{{ $t('events.plural') }}</h3>
							<div class="general-button slim" @click="openPopup('create_event')" v-if="permissionToCreateEvent">
								<i class="fal fa-plus tw-ml-0 tw-text-lg"></i>
							</div>
						</div>
						<div class="tw-hidden md:tw-block">
							<h3 class="tw-text-2xl tw-font-bold tw-leading-tight tw-mb-2">{{ $t('events.plural') }}</h3>
							<p class="text-normal tw-leading-loose">{{ $t('events.intro_part_first') }} {{ $t('events.plural').toLowerCase() }} {{ $t('events.intro_part_second') }}{{ permissionToCreateEvent ? `, ${$t('events.start_your_own')}` : '!' }}</p>
						</div>
					</div>
					<p class="text-normal tw-leading-loose md:tw-hidden">{{ $t('events.intro_part_first') }} {{ $t('events.plural').toLowerCase() }} {{ $t('events.intro_part_second') }}{{ permissionToCreateEvent ? `, ${$t('events.start_your_own')}` : '!' }}</p>
				</div>

				<div class="tw-flex tw-flex-col tw-mx-6 md:tw-mx-0 device:tw-justify-between device:tw-flex-row">
					<div class="create-event-btn-wrapper md:tw-grid md:tw-gap-x-3 md:tw-grid-cols-2" v-if="$user">
						<div class="general-button btn-v2 tw-self-start tw-hidden md:tw-inline-block device:tw-mr-3" @click="openPopup('create_event')" v-if="permissionToCreateEvent">
							{{ $t('events.singular') }} {{ $t('events.add').toLowerCase() }}
							<i class="fal fa-plus"></i>
						</div>
					</div>
					<!-- filter -->
					<div class="tw-grid tw-mt-4 tw-flex-1 tw-grid-cols-1 tw-gap-y-3 xs:tw-gap-y-0 xs:tw-gap-x-3 xs:tw-grid-cols-2 device:tw-mt-0 tw-items-start" v-if="!hideFilter">
						<form-select v-model="category_filter" :options="filteredCategories" name_clean="id" display_name="name" :clearable="true" :color_tag="true" @change="changeCategoryFilter" :placeholder="$t('events.categories')" @clickedOnEmpty="clearUrlFilter" class="tw-z-10"></form-select>
						<div class="filter tw-flex-1 tw-flex tw-flex-col tw-items-center tw-bg-white tw-rounded tw-cursor-pointer tw-relative" v-click-outside="handleCloseFilter">
							<div class="filter-top tw-flex tw-justify-between tw-w-full tw-px-6 tw-py-4 tw-relative tw-cursor-pointer" @click="handleDropdownFilter">
								<h4 class="tw-text-normal" :class="dropdownOpen ? 'secondary-c' : 'tw-text-gray-400'">{{ $t('events.filter') }}</h4>
								<i class="fal fa-angle-down tw-transform" :class="{'rotate': dropdownOpen}"></i>
							</div>
							<div :class="dropdownOpen ? 'tw-min-h-full tw-pb-5 tw-pt-5' : 'tw-h-0' " class="filter-dropdown tw-w-full tw-absolute tw-bg-white tw-px-6 tw-rounded tw-rounded-t-none tw-overflow-hidden">
								<div class="tw-text-sm">
									<h4 class="tw-font-semibold">{{ $t('events.privacy_accessibility') }}</h4>
									<ul class="tw-w-full tw-mt-4">
										<li class="tw-flex">
											<label class="relative tw-flex tw-items-center tw-cursor-pointer">
												<div class="radio-container">
													<input type="radio" name="privacy" value="" class="radio" v-model="privacy_status" @change="handleClickOnFilterOptions">
													<span class="radio-button"></span>
												</div>
												<span class="tw-font-normal block tw-ml-3">{{ $t('general.all') }}</span>
											</label>
										</li>
										<li class="tw-flex tw-my-2">
											<label class="relative tw-flex tw-items-center tw-cursor-pointer">
												<div class="radio-container">
													<input type="radio" name="privacy" value="public" class="radio" v-model="privacy_status" @change="handleClickOnFilterOptions">
													<span class="radio-button"></span>
												</div>
												<span class="tw-font-normal block tw-ml-3">{{ $t('fields.public') }}</span>
											</label>
										</li>
										<li class="tw-flex">
											<label class="relative tw-flex tw-items-center tw-cursor-pointer">
												<div class="radio-container">
													<input type="radio" name="privacy" value="private" class="radio" v-model="privacy_status" @change="handleClickOnFilterOptions">
													<span class="radio-button"></span>
												</div>
												<span class="tw-font-normal block tw-ml-3">{{ $t('fields.private') }}</span>
											</label>
										</li>
									</ul>
								</div>
								<div class="tw-mt-6 tw-text-sm" v-if="$user">
									<h4 class="tw-font-semibold">{{ $t('general.view') }}</h4>
									<ul class="tw-w-full tw-mt-4 tw-font-normal">
										<li class="tw-flex tw-mt-2">
											<label class="relative tw-flex tw-items-center tw-cursor-pointer">
												<div class="radio-container">
													<input ref="mine" type="radio" name="view" value="future" class="radio" v-model="view" @change="showFutureEvents">
													<span class="radio-button"></span>
												</div>
												<span class="tw-font-normal block tw-ml-3">{{ $t('general.all') }}</span>
											</label>
										</li>
										<li class="tw-flex tw-mt-2">
											<label class="relative tw-flex tw-items-center tw-cursor-pointer">
												<div class="radio-container">
													<input ref="mine" type="radio" name="view" value="past" class="radio" v-model="view" @change="showPastEvents">
													<span class="radio-button"></span>
												</div>
												<span class="tw-font-normal block tw-ml-3">{{ $t('events.past') }}</span>
											</label>
										</li>
										<li class="tw-flex tw-mt-2">
											<label class="relative tw-flex tw-items-center tw-cursor-pointer">
												<div class="radio-container">
													<input ref="mine" type="radio" name="view" value="mine" class="radio" v-model="view" @change="showMineEvents">
													<span class="radio-button"></span>
												</div>
												<span class="tw-font-normal block tw-ml-3">{{ $t('general.my') }} {{ $t('events.plural').toLowerCase() }}</span>
											</label>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>

				<template v-if="initial_pagination_finished">
					<div v-if="paginationItemsLength > 0" class="tw-mt-7">
						<div class="tw-flex tw-justify-between tw-mx-6 md:tw-mx-0" v-if="view === 'past'">
							<h3 class="tw-text-xl tw-font-bold">{{ $t('events.previous') }} {{ $t('events.plural').toLowerCase() }}</h3>
							<span class="secondary-c tw-cursor-pointer hover-opacity" @click="showFutureEvents"> {{ $t('general.view') }} {{ $t('events.planned').toLowerCase() }} {{ $t('events.plural').toLowerCase() }} </span>
						</div>
						<div id="group-index-cards" class="tw-flex tw-flex-col tw-mt-6">
							<day-list v-for="(events, name) in visibleEvents" :events="events" :name="name" :key="name"></day-list>
						</div>
					</div>
					<div class="tw-flex tw-flex-col tw-text-center tw-items-center" v-else-if="!loading">
						<events-empty-state-svg></events-empty-state-svg>
						<p class="tw--mt-8 tw-leading-relaxed normal-text">{{ $t('groups.it_seems') }} {{ $t('events.plural').toLowerCase() }} {{ $t('groups.no_filters') }}.</p>
						<template v-if="permissionToCreateEvent">
							<br />
							<p class="tw-leading-relaxed normal-text tw--mt-4">{{ $t('groups.start_one') }}</p>
							<div class="general-button btn-v2 tw-mt-6" @click="openPopup('create_event')">
								{{ $t('groups.start_a') }} {{ $t('events.singular').toLowerCase() }}
								<i class="far fa-plus"></i>
							</div>
						</template>
					</div>
				</template>

				<div class="tw-inline-flex tw-mt-10 tw-justify-center tw-w-full" v-if="currently_paginating || !initial_pagination_finished">
					<i class="far fa-spinner fa-spin light-text tw-text-3xl"></i>
				</div>
			</div>

			<template v-slot:sidebar>
				<sidebar-tab :title="$t('events.calendar')" icon="calendar-alt" icon_type="fal" :card_on_mobile="false">
					<template v-slot:header-actions>
						<p class="tw-text-gray-400 tw-text-sm tw-cursor-pointer hover:tw-opacity-75" v-text="$t('events.select_today')" @click="setToday"></p>
					</template>
					<FunctionalCalendar :configs="calendar_config" ref="sidebar_calendar" @dayClicked="changeDayFilter" @changedMonth="getTimePeriodCalendar" :key="calendarClearKey" id="sidebar-calendar"></FunctionalCalendar>
				</sidebar-tab>

				<sidebar-tab :title="$t('events.past')" icon="history" icon_type="fal" :card_on_mobile="false" v-if="pastEvents.length > 0">
					<template v-for="(pastEvent, index) in pastEvents">
						<router-link :to="{name: 'events.show', params: { event_slug: pastEvent.slug }}" :key="pastEvent.id">
							<sidebar-event :tEvent="pastEvent" :key="pastEvent.id" v-if="index < 5"></sidebar-event>
						</router-link>
					</template>
					<div class="tw-flex tw-justify-end" v-if="pastEvents.length > 5">
						<span class="secondary-c tw-cursor-pointer hover-opacity" @click="showPastEvents">{{ $t('general.view')}} {{ $t('general.all').toLowerCase() }}</span>
					</div>
				</sidebar-tab>
			</template>
		</custom-form>
	</div>
</template>

<script>
import { mapActions, mapState} from 'vuex';
import moment from 'moment';
import Global from '../../mixins/Global';
import SimplePagination from '../../mixins/SimplePagination';
import Modal from '../../mixins/v2/Modal';
import EventMixin from '../../mixins/v2/EventMixin';
import HuddleEvent from '../../lib/models/Event';
import EventCategory from '../../lib/models/EventCategory';

import EventCard from '../../components/events/Card.vue';
import EventModal from '../../components/events/EventModal.vue';
import FormSelect from '../../components/ui/FormSelect.vue';
import SidebarEvent from '../../components/events/sidebar/SidebarEvent.vue';
import Empty from './Empty.vue';
import DayList from '@/resources/assets/js/vue/components/events/DayList.vue';
import { FunctionalCalendar } from 'vue-functional-calendar';
import vClickOutside from 'v-click-outside';

export default {
	name: 'EventsIndex',

	mixins: [
		Global,
		Modal,
		SimplePagination,
		EventMixin
	],

	directives: {
		clickOutside: vClickOutside.directive,
	},

	components: {
		'event-card': EventCard,
		'event-modal': EventModal,
		'events-empty-state-svg': Empty,
		'form-select': FormSelect,
		'sidebar-event': SidebarEvent,
		'day-list': DayList,
		FunctionalCalendar,
	},

	data() {
		return {
			privacy_status: '',
			view: 'future',
			category_filter: null,
			events_loaded: false,
			my_events_loaded: false,
			selected_day_filter: false,
			loading: false,
			dropdownOpen: false,
			hideFilter: false,
			calendar_config: {
				sundayStart: true,
				changeMonthFunction: true,
				changeYearFunction: true,
				isDatePicker: true,
				dateFormat: 'yyyy-mm-dd',
			},
			calendarClearKey: '',
			past_events: [],
			pagination_settings: {
				paginate_until_scrollable: true,
                minimum_pagination_items: 10,
			},
			// tenant_id,
            // live_beta_tenant_ids: [92, 21, 2, 4595, 7459, 6110, 4072, 3827, 4004, 3614, 6276, 5746, 6510, 2977, 3966, 1993, 4288, 3273, 6850, 31, 3728, 3555, 6995, 3730, 7354, 3639, 2879, 2929, 5193, 4399, 4513, 4281, 2824, 3267, 4304,3180,4599,5978,4823,5965,4581,3896,3661,4980,3194,2634,4265,4126,4158,4330,5999,6080,3800,4344,3262,3491,5955,2626,6354,2791,838,3679,4574,2546,6693,2845,3060,1671,2643,3073,3905,4028,2849,2401,3723,4164,7562,6561,2413,3437,6127,6323,5370,6967,2826,2224,7417,2810,6833,2527,2751,3063,7582,6367,5855,2791,2838,4146,7175,4400],
		};
	},

	watch: {
		$route(to) {
			if (to.query.category) {
				this.category_filter = parseInt(to.query.category);

				this.startPagination(true);
			}
		}
	},

	created() {
		document.title = this.$t('events.plural');
		const url_params = new URLSearchParams(window.location.search);

		if (url_params.has('category')){
			this.category_filter = parseInt(url_params.get('category'));
		}
	},

	computed: {
		...mapState('db/events', ['events_time_period']),
		categories() {
			return EventCategory.all();
		},

		filteredCategories() {
			return EventCategory.query().where('events_count' , (count) => count > 0).get();
		},

		month() {
			return moment(new Date).format('MMM').slice(0, -1).toUpperCase();
		},

		day() {
			return moment(new Date).format('D');
		},

		visibleEvents() {
			let query = HuddleEvent.query();

			if (this.privacy_status !== '') {
				if (this.privacy_status === 'public') {
					query = query.where('status', 'public');
				} else {
					query = query.where('status', 'private');
				}
			}

			if (this.category_filter !== null) {
				query = query.where('category_id', this.category_filter);
			}

			let ordered_events;

			if (this.view === 'future' || this.view === 'mine') {
				if (this.selected_day_filter) {
					query = query.where('end_date', (date) => moment(date, 'MMMM DD, YYYY HH:mm').format('YYYY-MM-DD') >= moment(this.selected_day_filter, 'YYYY-M-DD').format('YYYY-MM-DD'));
				} else {
					const today = moment(new Date).format('YYYY-MM-DD HH:mm');
					query = query.where('end_date', (date) => moment(date, 'MMMM DD, YYYY HH:mm').format('YYYY-MM-DD HH:mm') >= today);
				}

				ordered_events = query.get().sort((a, b) => new Date(moment(a.start_date, 'MMMM DD, YYYY HH:mm').format()) - new Date(moment(b.start_date, 'MMMM DD, YYYY HH:mm').format()));
			} else if (this.view === 'past') {
				query = query.where('past', true);
				ordered_events = query.get().sort((a, b) => new Date(moment(a.start_date, 'MMMM DD, YYYY HH:mm').format()) - new Date(moment(b.start_date, 'MMMM DD, YYYY HH:mm').format())).reverse();
			}

			const dates = {};

			for (let i = 0; i < ordered_events.length; i += 1) {
				const date = moment(ordered_events[i].start_date, 'MMMM DD, YYYY HH:mm').format('YYYY-MM-DD');

				if (!(date in dates)) {
					dates[date] = [];
				}

				dates[date].push(ordered_events[i]);
			}

			return dates;
		},

		paginationItemsLength() {
			return Object.keys(this.visibleEvents).length;
		},

		pastEvents() {
			return this.past_events.sort((a, b) => new Date(moment(a.end_date, 'MMMM DD, YYYY HH:mm').format()) - new Date(moment(b.end_date, 'MMMM DD, YYYY HH:mm').format())).reverse();
		},

		permissionToCreateEvent() {
			if (this.$settings('events.user_create') || this.$user.isModerator) {
				return true;
			}
			return false;
		}
	},

	methods: {
		...mapActions('db/events', ['getEventsTimePeriod']),
		paginate(reset = false) {
			this.loading = true;

			if (reset) {
				this.pagination = {};
				this.events_loaded = false;
				HuddleEvent.deleteAll();
			}

			const params = new URLSearchParams();

			if (this.privacy_status !== '') {
				params.append('where', `status:${this.privacy_status}`);
			}

			if (this.category_filter !== null) {
				params.append('where', `category_id:${this.category_filter}`);
			}

			const today = moment(new Date).format('YYYY-MM-DD HH:mm');

			if (this.view === 'future' || this.view === 'mine') {
				if (this.view === 'mine') {
					params.append('where_has', `members:user_id:${this.$user.id}`);
				}

				params.append('where_gte', this.selected_day_filter ? `end_date:${this.selected_day_filter}` : `end_date:${today}`);
			} else if (this.view === 'past') {
				params.append('where_lt', `end_date:${today}`);
			}

			params.append('page', this.pagination.current_page ? this.pagination.current_page += 1 : 1);
			params.append('size', 10);

			if (this.view === 'past') {
				params.append('order_by', 'start_date:desc');
				params.append('sort_by_type', 'desc');
			} else {
				params.append('order_by', 'start_date:asc');
				params.append('sort_by_type', 'asc');
			}

			params.append('with', 'category,participation,memberSelection');

			return new Promise((resolve) => {
				HuddleEvent.api().fetch(params).then((result) => {
					this.loading = false;
					this.events_loaded = true;

					resolve(result.response);
					// To update the html to show the red notification circle
					setTimeout(() => this.$nextTick(() => Notifier.updateHTML()), 100)

				}).catch(() => {
					this.loading = false;
				});
			});
		},

		showPastEvents() {
			this.view = 'past';

			this.startPagination(true);
		},

		showFutureEvents() {
			this.view = 'future';

			this.startPagination(true);
		},

		showMineEvents() {
			this.view = 'mine';

			this.startPagination(true);
		},

		changeDayFilter(date) {
			if (this.view === 'past') {
				this.view = 'future';
			}

			this.selected_day_filter = date.date;

			this.startPagination(true);
		},

		setToday() {
			this.selected_day_filter = false;
			this.calendarClearKey = this.generateUUID();

			this.startPagination(true);

			this.getTimePeriodCalendar();
		},

		fetchPastEvents(pageSize) {
			const today = moment(new Date).format('YYYY-MM-DD HH:mm');

			HuddleEvent.api().fetchPastEvents(pageSize, today).then((past_events) => {
				this.past_events = past_events;
			});
		},

		handleDropdownFilter() {
			this.dropdownOpen = !this.dropdownOpen;
		},

		handleCloseFilter() {
			this.dropdownOpen = false;
		},

		clearUrlFilter() {
			if (this.$route.query.category) {
				this.$router.replace({'query': null});
			}
		},

		changeCategoryFilter() {
			if (this.category_filter === null) {
				this.clearUrlFilter();
			} else if (this.category_filter !== null) {
				this.$router.replace({'query': {category: this.category_filter}});
			}

			this.startPagination(true);
		},

		handleClickOnFilterOptions() {
			this.startPagination(true);
		},

		getTimePeriodCalendar() {
			setTimeout(() => {
				if (this.$refs.sidebar_calendar) {
					const { weeks } = this.$refs.sidebar_calendar.listCalendars[0];
					const dateFirstItemCalendar = weeks[0].days[0].date;
					const dateLastItemCalendar = weeks[weeks.length - 1].days[6].date;

					this.getEventsTimePeriod({
						start: dateFirstItemCalendar,
						end: dateLastItemCalendar,
					}).then(() => {
						this.amountOfEventsPerDay();
					})
				}
			}, 100)
		},

		amountOfEventsPerDay() {
			const event_dates = Object.entries(this.events_time_period);
			const { weeks } = this.$refs.sidebar_calendar.listCalendars[0];
			const targetDayAndWeek = [];
			const weeksElements = document.getElementById('sidebar-calendar').querySelectorAll('.vfc-week');

			event_dates.forEach((event_date, i) => {
				weeks.forEach((week, j) => {
					const formatDate = event_date[0].replace(/(^|-)0+/g, '$1');
					const weekOfMonth = j;
					week.days.forEach((day, index) => {
						if (day.date === formatDate) {
							targetDayAndWeek.push({
								day: index,
								weeknumber: weekOfMonth,
								total: event_date[1].length
							});
						}
					});
				})
			});

			targetDayAndWeek.forEach((target) => {
				const vfcWeek = weeksElements[target.weeknumber];
				const vfcDay = vfcWeek.querySelectorAll('.vfc-day');
				const calendarDay = vfcDay[target.day];

				if (calendarDay.getElementsByClassName('red-dot').length === 0) {
					const div = document.createElement('span');
					div.className = 'red-dot';
					div.innerHTML = target.total;
					calendarDay.append(div);
				}
			});
		}
	},

	mounted() {
		this.fetchPastEvents(10);
		this.fetchCategories();
		this.getTimePeriodCalendar();
	},
};
</script>

<style lang="scss">
.red-dot {
	@apply tw-absolute tw-text-center tw-rounded-full tw-text-white;
	bottom: 21px;
	left: 24px;
	width: 14px;
	height: 14px;
	background: #ff8a8f;
	font-size: 10px;
	color: white;
	z-index: 100;
}

.new-group-privacy-option {
	@apply tw-px-4 #{!important};
}

#group-index-cards {
	@media(max-width: 1130px) {
		@apply tw-gap-x-4 tw-gap-y-1;
	}

	@media(max-width: 550px) {
		@apply tw-grid-cols-1;
	}
}

.calendar-icon {
	width: 85px;

	@media (max-width: 576px) {
		width: 60px;
	}
}

.create-event-btn-wrapper {
	@media (min-width: 1024px) {
		@apply tw-block;
	}
}

.filter {
	z-index: 9;

	filter: drop-shadow(0px 0px 2px #00000029);
	height: 44px;

	.filter-top {
		@apply tw-overflow-hidden tw-rounded-t;

		&:hover {
			@apply tw-bg-white;
			filter: brightness(0.98);
		}
	}

	.fa-angle-down{
		&::before{
			@apply tw-inline-block;
			transition: transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
		}

		&.rotate::before{
			transform: rotate(-180deg);
		}
	}

	.filter-dropdown {
		top: 42px;

		.radio-container {
			@apply tw-cursor-pointer;
			width: 14px;
			height: 14px;

			.radio {
				position: absolute;
				opacity: 0;
				cursor: pointer;
				height: 0;
				width: 0;

				&:checked {
					& ~ .radio-button {
						&::after {
							@apply tw-block tw-rounded-full;
							top: 2px;
							left: 2px;
							width: 8px;
							height: 8px;
						}
					}
				}
			}

			.radio-button {
				@apply tw-absolute tw-bg-white tw-border tw-border-gray-400 tw-rounded-full;
				width: 14px;
				height: 14px;
				top: 2px;
				left: 0px;

				&::after {
					content: "";
					position: absolute;
					display: none;
				}
			}
		}
	}
}
</style>


